import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { Typography, Box } from '@mui/material'

import ComboBox from '../../../Components/ComboBox'
import CustomButton from '../../../Components/CustomButton/CustomButton'
import { Input } from '../../../Components/Input'
import { makeGetRequest, makePostRequest } from '../../../utils/api'
import urls from '../../../utils/urls'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import AddIcon from '@mui/icons-material/Add'

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    },
  },
}

const names = [
  'Oliver Hansen',
  'Van Henry',
  'April Tucker',
  'Ralph Hubbard',
  'Omar Alexander',
  'Carlos Abbott',
  'Miriam Wagner',
  'Bradley Wilkerson',
  'Virginia Andrews',
  'Kelly Snyder',
]

export default function CreateCompany({ fetchCompanys, setAddCompay, headerText = '' }) {
  const [getPays, setPays] = useState([])
  const [file, setFile] = useState(null)
  const [nameError, setNameError] = useState(false)

  const { handleSubmit, control, setValue, reset } = useForm({
    defaultValues: {
      Name: '',
      Address: '',
      Country: '',
      Groupe: '',
      logo: '',
      city: '',
    },
  })

  useEffect(() => {
    fetchPays()
  }, [])

  const handleClose = () => {
    setAddCompay(false)
    reset()
  }

  const onSubmit = async (data) => {
    const formData = new FormData()
    if (file != null) formData.append('Logo', file)
    formData.append('Name', data.Name)
    formData.append('Country', data.Country)
    formData.append('Groupe', data.Groupe)
    formData.append('city', data.city)
    formData.append('Address', data.Address)
    const response = await makePostRequest(
      urls.companyOperations,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
      true,
    )
    if (response.status === 201) {
      fetchCompanys()
      handleClose()
    } else if (response.status === 400) {
      response.data?.Name && setNameError(true)
    }
  }

  const fetchPays = async () => {
    const url = '/api/Social/get-countries/'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterPays = []
      data.forEach((v) => {
        filterPays.push({ label: `${v.CountryCode}/${v.Designation}`, id: v.id })
      })
      setPays([...filterPays])
    }
  }

  return (
    <>
      <Dialog fullWidth maxWidth="xs" open={true} onClose={handleClose}>
        <DialogTitle sx={{ backgroundColor: '#202020' }}>Ajouter {headerText}</DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <Button
              variant="contained"
              component="label"
              sx={{
                color: 'black',
                background: 'none',
                '&:hover': {
                  backgroundColor: '#aeaeae',
                },
              }}
            >
              Logo
              <input
                style={{ marginLeft: '20px', width: '100%' }}
                name="file"
                type="file"
                filename={file}
                required={true}
                accept="image/*"
                onChange={(e) => setFile(e.target.files[0])}
              />
            </Button>
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                required: true,
                size: 'small',
                type: 'text',
              }}
              rules={{ required: true }}
              name="Name"
              label="Nom"
              error={nameError}
              helperText={
                nameError
                  ? 'Organisaiton déjà existantes vous pouvez la sélectionner dans la liste'
                  : ''
              }
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                required: true,
                size: 'small',
                type: 'text',
              }}
              rules={{ required: true }}
              name="Address"
              label="Adresse"
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                required: true,
                size: 'small',
                type: 'text',
              }}
              rules={{ required: true }}
              name="city"
              label="Vile"
            />
            <ComboBox
              handleAutoComplete={(e, j) => setValue('Country', j.label)}
              label="Pays"
              data={getPays}
              name="Country"
              required={true}
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                required: true,
                size: 'small',
                type: 'text',
              }}
              rules={{ required: true }}
              name="Groupe"
              label="Groupe"
            />
          </DialogContent>
          <DialogActions>
            <Button type="submit">Valider</Button>
            <Button onClick={handleClose}>Annuler</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
